import * as React from 'react';

import { cn } from '@/new/lib/utils';

interface TextareaProps extends React.ComponentProps<'textarea'> {
  lengthLimit?: number;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, lengthLimit, value, onFocus, onBlur, ...props }, ref) => {
    const [focused, setFocused] = React.useState(false);

    const textareaEl = (
      <textarea
        className={cn(
          'flex field-sizing-content min-h-[60px] w-full rounded-md border bg-white px-3 py-2 ring-offset-2 ring-offset-transparent placeholder:text-gray-400/80 focus-visible:ring-1 focus-visible:ring-teal-500 focus-visible:ring-offset-white focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          lengthLimit !== undefined && 'pb-5.75',
          className,
        )}
        ref={ref}
        value={value}
        onFocus={(e) => {
          setFocused(true);
          onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          onBlur?.(e);
        }}
        {...props}
      />
    );

    if (lengthLimit === undefined) {
      return textareaEl;
    }

    const length = typeof value === 'string' ? value.length : 0;
    const overLimit = length > lengthLimit;

    return (
      <div className="relative">
        {textareaEl}
        <div
          className={cn(
            'pointer-events-none absolute right-0 bottom-0 m-1 rounded-lg bg-white px-1.5 py-0.25 text-xs text-gray-300 transition-opacity duration-200',
            focused || overLimit ? 'opacity-100' : 'opacity-0',
            overLimit && 'text-red-500',
          )}
        >
          {length} / {lengthLimit}
        </div>
      </div>
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
